module.exports = __webpack_public_path__ + "img/LagoonTrifidNebulae_261s_iso1250_thumb.c29b8536.jpg";